import { Overlay } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    DestroyRef,
    OnInit,
    Signal,
    WritableSignal,
    computed,
    effect,
    signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MAT_SELECT_SCROLL_STRATEGY } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';
import { BusinessProcessTaskDataInterface, CostObject } from 'app/api';
import { DialogBuilderComponent } from 'app/core/dialogBuilder/dialog-builder.component';
import getDisplayedFieldColumns from 'app/modules/task/right-contents/maintain-form-components/maintain-interface-components/custom-form-templates/select-dictionary-field-dialog/displayed-field-columns';
import {
    GridViewsModule,
    TableColumnDef,
} from '../../../../../../../projects/grid-views/src/public-api';
import { AifDialogItemComponent } from './aif-dialog-item/aif-dialog-item.component';
import { AifDialogService } from './aif-dialog.service';

@Component({
    selector: 'aif-dialog',
    imports: [
        CommonModule,
        MatButtonModule,
        MatStepperModule,
        GridViewsModule,
        AifDialogItemComponent,
        TranslocoModule,
    ],
    templateUrl: './aif-dialog.component.html',
    styleUrl: './aif-dialog.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        AifDialogService,
        {
            provide: MAT_SELECT_SCROLL_STRATEGY,
            useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.reposition(),
            deps: [Overlay],
        },
    ],
})
export class AifDialogComponent extends DialogBuilderComponent<any> implements OnInit {
    _translocoContent = signal(null);

    items: Signal<BusinessProcessTaskDataInterface[]> = computed(() => this.service.items);

    data: WritableSignal<any> = signal([]);
    displayedColumns: Signal<Array<TableColumnDef>> = computed(() =>
        getDisplayedFieldColumns(this._translocoContent())
    );
    dataSource: Signal<MatTableDataSource<CostObject>>;
    selection: WritableSignal<any[]> = signal([]);

    selectedIO: Signal<string> = computed(() => this.service.io);
    selectedItem: Signal<BusinessProcessTaskDataInterface> = computed(() => this.service.item);

    constructor(
        private service: AifDialogService,
        private _destroy: DestroyRef,
        private _translocoService: TranslocoService
    ) {
        super();

        this._translocoService
            .selectTranslation('bpTask')
            .pipe(takeUntilDestroyed(this._destroy))
            .subscribe(content => {
                this._translocoContent.set(content);
            });

        effect(() => {
            this.data.set(this.service.fieldsInItem);
        });

        this.dataSource = computed(
            () => new MatTableDataSource(this.data()) ?? new MatTableDataSource([])
        );
    }

    onRowSelected($event: any): void {
        if (!$event[0]) {
            return;
        }
        this.selection.set($event);
    }

    selectIO(io: 'input' | 'output'): void {
        this.service.setIO(io);
    }
    selectItem(item: BusinessProcessTaskDataInterface): void {
        this.service.setItem(item);
    }
    selectFields(): void {
        this.closeDialog({
            itemName: this.selectedItem().description,
            fields: this.selection(),
        });
    }

    trackByFn(index: number, item: BusinessProcessTaskDataInterface): string {
        return `${index}-${item.description}`;
    }
}
